<template>
    <nuxt-link :to="shortcut.uri" class="text-decoration-none">
        <card-container class="contact-us-shortcut" no-header no-footer body-class="p-24">
            <template #body>
                <div class="text-color primary">
                    <Heading
                        color="primary"
                        class="f-w-700 m-b-8"
                        tag="p"
                        size="web-xx-sm"
                        style="letter-spacing: -0.5px;"
                    >
                        {{ shortcut.heading }}
                    </Heading>

                    <Texture
                        size="md"
                        color="accent-2nd"
                        class="d-flex align-items-center f-w-500 m-0"
                    >
                        {{ shortcut.description }} <span class="icon chevron chevron-right-compact bg-color accent accent-2nd" />
                    </Texture>
                </div>
            </template>
        </card-container>
    </nuxt-link>
</template>

<script>
export default {
    props: {
        shortcut: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss">
.contact-us-shortcut {
    .card-body {
        text-align: left;
        padding: 24px !important;
    }
}
</style>
